import { Card, ListGroup, Badge } from "react-bootstrap";
import { Gear } from "react-bootstrap-icons";

function HomeGroupCard({ title, description, items = [] }) {
    return (
        <Card className="h-100 border-0 shadow-sm w-50">
            <Card.Body className="p-3">
                <div className="d-flex align-items-start justify-content-between">
                    <div className="d-flex gap-2 align-items-center">
                        <div className="icon-chip">
                            <Gear size={18} />
                        </div>
                        <div>
                            <Card.Title className="mb-1">{title}</Card.Title>
                            <div className="text-muted" style={{ fontSize: 12 }}>
                                {description}
                            </div>
                        </div>
                    </div>

                    <Badge bg="secondary" pill>{items.length}</Badge>
                </div>

                <ListGroup className="list-group-flush mt-3">
                    {items.map((it) => (
                        <ListGroup.Item key={it.title} className="px-0">
                            <a className="text-decoration-none fw-semibold" href={it.mainUrl}>
                                {it.title}
                            </a>
                            <div className="text-muted" style={{ fontSize: 12 }}>
                                {it.mainLabel}
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Card.Body>

            <style>{`
        .icon-chip {
          width: 34px; height: 34px;
          border-radius: 10px;
          display: grid; place-items: center;
          background: rgba(13,110,253,.10);
          color: #0d6efd;
        }
      `}</style>
        </Card>
    );
}

export default HomeGroupCard;